import React, { Component } from 'react';
import { selectDonationType } from '../../type/config-status';

export default class extends Component {
    render() {
        // 단일 탭
        var isTabBoxOne = " one";

        if (this.props.donation.usePledge && this.props.donation.useOneOff)
            isTabBoxOne = "";

        return (
            <div className="donation-tab">
                <div className={"tab-box" + isTabBoxOne}>
                    <TabBox
                        TabBoxTarget={selectDonationType.Pledge}
                        title={this.props.donation.pledge.title}
                        selectDonationType={this.props.selectDonationType}
                        isUse={this.props.donation.usePledge}
                        onSelectDonationType={function (selectDonationType) {
                                this.props.onSelectDonationType(selectDonationType);
                        }.bind(this)}
                    />
                    <TabBox
                        TabBoxTarget={selectDonationType.Oneoff}
                        title={this.props.donation.oneOff.title}
                        selectDonationType={this.props.selectDonationType}
                        isUse={this.props.donation.useOneOff}
                        onSelectDonationType={function (selectDonationType) {
                            this.props.onSelectDonationType(selectDonationType);
                        }.bind(this)}
                    />
                </div>
            </div>
        )
    }
}

class TabBox extends Component {
    render() {
        if (this.props.isUse === true) {
            // 버튼 활성화 
            var isActive = false;

            if (this.props.selectDonationType === this.props.TabBoxTarget)
                isActive = true;

            // 컴포넌트 리턴
            return (
                <a
                    className={"btn-tab " + ((isActive) ? "active" : "")}
                    onClick={function () { this.props.onSelectDonationType(this.props.TabBoxTarget); }.bind(this)}
                >{this.props.title}</a>
            );
        } else {
            return <a className="btn-tab hidden">{this.props.title}</a>
        }
        
    }
}






// WEBPACK FOOTER //
// ./src/components/content/DonationTab.js